import {
  IWorkItOutData,
  IPickAPlanData,
  PromoCodeDiscount,
  IContactDetails,
  ICompanyDetails,
  IPayroll,
  ISummary,
} from 'types';

export enum TYPES {
  SET_WORK_IT_OUT = '[SIGN_UP]-SET_WORK_IT_OUT',
  SET_PICK_A_PLAN = '[SIGN_UP]-SET_PICK_A_PLAN',
  SET_IS_CHARITY = '[SIGN_UP]-SET_IS_CHARITY',

  SET_DEFAULT_PROMO_CODE = '[SIGN_UP]-SET_DEFAULT_PROMO_CODE',
  CLEAR_PROMO_CODE_STATUS = '[SIGN_UP]-CLEAR_PROMO_CODE_STATUS',
  APPLY_PROMO_CODE = '[SIGN_UP]-APPLY_PROMO_CODE',
  APPLY_PROMO_CODE_SUCCESS = '[SIGN_UP]-APPLY_PROMO_CODE_SUCCESS',
  APPLY_PROMO_CODE_FAILURE = '[SIGN_UP]-APPLY_PROMO_CODE_FAILURE',

  APPLY_REFERRAL_CODE = '[SIGN_UP]-APPLY_REFERRAL_CODE',

  SET_CONTACT_DETAILS = '[SIGN_UP]-SET_CONTACT_DETAILS',
  SET_COMPANY_DETAILS = '[SIGN_UP]-SET_COMPANY_DETAILS',
  SET_ACCOUNTANT_DETAILS = '[SIGN_UP]-SET_ACCOUNTANT_DETAILS',

  SET_PAYROLL = '[SIGN_UP]-SET_PAYROLL',
  SET_SUMMARY = '[SIGN_UP]-SET_SUMMARY',

  SUBMIT = '[SIGN_UP]-SUBMIT',
  SUBMIT_SUCCESS = '[SIGN_UP]-SUBMIT_SUCCESS',
  SUBMIT_FAILURE = '[SIGN_UP]-SUBMIT_FAILURE',

  SUBMIT_CLEAR = '[SIGN_UP]-SUBMIT_CLEAR',
}

export type SignUpActions =
  ISaveWorkItOut |
  ISavePickAPlan |
  ISaveIsCharity |
  ISetDefaultPromoCode |
  IClearPromoCodeStatus |
  IApplyPromoCode |
  IApplyPromoCodeSuccess|
  IApplyPromoCodeFailure |
  IApplyReferralCode |
  ISaveContactDetails |
  ISaveCompanyDetails |
  ISetPayroll |
  ISetSummary |
  ISignUpSubmit |
  ISignUpSubmitSuccess |
  ISignUpSubmitFailure |
  ISaveAccountantDetails |
  ISubmitClear;

// =====================
// Save work it out step
// =====================
export interface ISaveWorkItOut {
  type: typeof TYPES.SET_WORK_IT_OUT;
  payload: IWorkItOutData;
}

export function actionSaveStepWorkItOut({
  payRuns,
  managePayCycles,
  manageHr,
  bankChoice,
  bankOther,
}: IWorkItOutData): ISaveWorkItOut {
  return {
    type: TYPES.SET_WORK_IT_OUT,
    payload: {
      payRuns,
      managePayCycles,
      manageHr,
      bankChoice,
      bankOther,
    },
  };
}

// =====================
// Save pick a plan step
// =====================
export interface ISavePickAPlan {
  type: typeof TYPES.SET_PICK_A_PLAN;
  payload: IPickAPlanData;
}

export function actionSaveStepPickAPlan({
  chosenPlan,
  extras,
}: IPickAPlanData): ISavePickAPlan {
  return {
    type: TYPES.SET_PICK_A_PLAN,
    payload: {
      chosenPlan,
      extras,
    },
  };
}

// =====================
// Save is charity
// =====================
export interface ISaveIsCharity {
  type: typeof TYPES.SET_IS_CHARITY;
  payload: boolean;
}

export function actionSaveIsCharity(isCharity: boolean): ISaveIsCharity {
  return {
    type: TYPES.SET_IS_CHARITY,
    payload: isCharity,
  };
}

// =====================
// Save promo code
// =====================

export interface ISetDefaultPromoCode {
  type: typeof TYPES.SET_DEFAULT_PROMO_CODE;
  payload: {
    promoCode: string;
  }
}

export function actionSetDefaultPromoCode(promoCode: string): ISetDefaultPromoCode {
  return {
    type: TYPES.SET_DEFAULT_PROMO_CODE,
    payload: {
      promoCode,
    },
  };
}

export interface IClearPromoCodeStatus {
  type: typeof TYPES.CLEAR_PROMO_CODE_STATUS;
  payload: null;
}

export function actionClearPromoCodeStatus(): IClearPromoCodeStatus {
  return {
    type: TYPES.CLEAR_PROMO_CODE_STATUS,
    payload: null,
  };
}

export interface IApplyPromoCode {
  type: typeof TYPES.APPLY_PROMO_CODE;
  payload: {
    promoCode: string;
  };
}

export function actionApplyPromoCode(promoCode: string): IApplyPromoCode {
  return {
    type: TYPES.APPLY_PROMO_CODE,
    payload: {
      promoCode,
    },
  };
}

export interface IApplyPromoCodeSuccess {
  type: typeof TYPES.APPLY_PROMO_CODE_SUCCESS;
  payload: {
    promoCodeDiscount: PromoCodeDiscount;
  };
}

export function actionApplyPromoCodeSuccess(promoCodeDiscount: PromoCodeDiscount): IApplyPromoCodeSuccess {
  return {
    type: TYPES.APPLY_PROMO_CODE_SUCCESS,
    payload: {
      promoCodeDiscount,
    },
  };
}

export interface IApplyPromoCodeFailure {
  type: typeof TYPES.APPLY_PROMO_CODE_FAILURE;
  payload: {
    promoCodeError: string;
  };
}

export function actionApplyPromoCodeFailure(promoCodeError: string): IApplyPromoCodeFailure {
  return {
    type: TYPES.APPLY_PROMO_CODE_FAILURE,
    payload: {
      promoCodeError,
    },
  };
}

// =====================
// Save referral code
// =====================

export interface IApplyReferralCode {
  type: typeof TYPES.APPLY_REFERRAL_CODE;
  payload: {
    referralCode: string;
  };
}

export function actionApplyReferralCode(referralCode: string): IApplyReferralCode {
  return {
    type: TYPES.APPLY_REFERRAL_CODE,
    payload: {
      referralCode,
    },
  };
}

// =====================
// Set contact details
// =====================

export interface ISaveContactDetails {
  type: typeof TYPES.SET_CONTACT_DETAILS;
  payload: IContactDetails;
}

export function actionSetContactDetails(payload: IContactDetails): ISaveContactDetails {
  return {
    type: TYPES.SET_CONTACT_DETAILS,
    payload: {
      ...payload,
    },
  };
}

// =====================
// Set contact details
// =====================

export interface ISaveAccountantDetails {
  type: typeof TYPES.SET_ACCOUNTANT_DETAILS;
  payload: ICompanyDetails;
}

export function actionSetAccountantDetails(payload: ICompanyDetails): ISaveAccountantDetails {
  return {
    type: TYPES.SET_ACCOUNTANT_DETAILS,
    payload: {
      ...payload,
    },
  };
}

// =====================
// Set company details
// =====================

export interface ISaveCompanyDetails {
  type: typeof TYPES.SET_COMPANY_DETAILS;
  payload: ICompanyDetails;
}

export function actionSetCompanyDetails(payload: ICompanyDetails): ISaveCompanyDetails {
  return {
    type: TYPES.SET_COMPANY_DETAILS,
    payload: {
      ...payload,
    },
  };
}

// =====================
// Set payroll information
// =====================
export interface ISetPayroll {
  type: typeof TYPES.SET_PAYROLL;
  payload: IPayroll;
}

export function actionSetPayroll(payload: IPayroll): ISetPayroll {
  return {
    type: TYPES.SET_PAYROLL,
    payload: {
      ...payload,
    },
  };
}

// =====================
// Set summary
// =====================
export interface ISetSummary {
  type: typeof TYPES.SET_SUMMARY;
  payload: ISummary;
}

export function actionSetSummary(payload: ISummary): ISetSummary {
  return {
    type: TYPES.SET_SUMMARY,
    payload: {
      ...payload,
    },
  };
}

// =====================
// Submit
// =====================
export interface ISignUpSubmit {
  type: typeof TYPES.SUBMIT;
  payload: null;
}

export function actionSubmit(): ISignUpSubmit {
  return {
    type: TYPES.SUBMIT,
    payload: null,
  };
}

export interface ISignUpSubmitSuccess {
  type: typeof TYPES.SUBMIT_SUCCESS;
  payload: null;
}

export function actionSubmitSuccess(): ISignUpSubmitSuccess {
  return {
    type: TYPES.SUBMIT_SUCCESS,
    payload: null,
  };
}

export interface ISignUpSubmitFailure {
  type: typeof TYPES.SUBMIT_FAILURE;
  payload: {
    error: string;
  };
}

export function actionSubmitFailure(error: string): ISignUpSubmitFailure {
  return {
    type: TYPES.SUBMIT_FAILURE,
    payload: {
      error,
    },
  };
}

export interface ISubmitClear {
  type: typeof TYPES.SUBMIT_CLEAR;
  payload: null;
}
